<template>
<div class="" style="">

   <div class="row  yo-text-normal "  >
      <div class="col s12 m10m offset-m1m yo-bg-color-tertiary">
        <div class="row" style="border:2px solid #fff;padding:20px 20px;">




            
            <div class="row ">
              <div class="col s12 " style="padding-bottom:10px;"><h3 class="yo-align-center yo-bold" style="margin:0;">Benvenuto</h3></div>
              <div class="col s12 m6 offset-m3"><el-input class="no-border" placeholder="Email" v-model.trim="form.email" auto-complete="off"></el-input></div>
              <div class="col s12 m6 offset-m3" style="padding-top:20px;padding-bottom:20px;"><el-input class="no-border" placeholder="Password" type="password" v-model.trim="form.password" auto-complete="off"  ></el-input></div>
            
              <div class="col s12 m6 offset-m3 yo-align-center yo-pointer yo-valign-text-center  yo-text-bold" v-on:click="goLogin" style="background:#FDE1AE;height:42px;">ACCEDI</div>
            </div>

            <div class="row " style="border-top:3px dotted #fff;margin-top:50px;padding-top:30px;">
              <div class="col s12 m6 offset-m3 " style="padding-bottom:20px;"><h3 style="margin:0;">Password dimenticata?</h3>Se hai dimenticato la tua password inserisci la tua email</div>
            
              <div class="col s12 m6 offset-m3 " style="padding-bottom:20px;"><el-input class="no-border" placeholder="Email per recupero password" v-model.trim="form.recovery" auto-complete="off"></el-input></div>
           
              <div class="col s12 m6 offset-m3 yo-align-center yo-pointer yo-valign-text-center  yo-text-bold " v-on:click="getPassword" style="background:#FDE1AE;height:42px;">Richiedi Password</div>
            </div>


        </div>
      </div>
   </div>


   

   <!-- SEZIONE AREE -->
   <aree></aree>
   
</div>
</template>

<script>
import emailRecovery from './Email-recovery.vue'
import calendar from '../components/Calendar'
import eventiInteresse from '../components/Eventi-interesse'
import aree from '../components/Aree'


export default {
   name: 'home',
   components: {
      calendar,
      eventiInteresse,
      aree
   },
   created () {
      this.$teras.page.title = "Mylogin Accesso"
      this.$teras.page.sezione = "myLogin"
   },
   data() {
    return {
      form: {
        email: '',
        password: '',
        recovery:''
      },
      rules: {
        uname: [
          { required: true, message: 'La email è obbligatoria', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'La password è obbligatoria', trigger: 'blur' }
        ]        
      }
    };
  },
  methods: {
    getPassword() {
      if(this.form.recovery!=''){
        var parent = this
        this.axios.query('fetchAll','SELECT * FROM bm_bvent.contatto AS ana WHERE ana.email = →recovery ',this.form).then((data) => {
          console.log("PASSWORD CHECK "+data.result.length)
          console.log(data)
          if(data.result.length == 1 && data.result[0].id > 0){
            //var html = this.$teras.renderVue(emailRecovery,{contatto:data.result[0]})
            //data.result[0].email
            parent.axios.email({
              to:data.result[0].email,
              from:'biomedia@biomedia.net',
              oggetto:'MyLogin credenziali di accesso per '+data.result[0].nome+' '+data.result[0].cognome,
              body:this.$teras.renderVue(emailRecovery,{contatto:data.result[0]}),
              css:'https://next.biomedia.net/eventi/css/basic.css,https://next.biomedia.net/eventi/css/grid.css,https://next.biomedia.net/eventi/css/layout.css,https://next.biomedia.net/eventi/css/email.css'
              
          }).catch((error) => {
              console.log("ERRORE NELL'INVIO DELLA EMAIL")
              console.log(error)
            })

            
            var args = {idContatto: data.result[0].id, lingua:'ita'}
              this.$alert('Complimenti, le abbiamo inviato le credenziali di accesso al suo indirizzo email', 'Recupero Password', {confirmButtonText: 'Chiudi' })

          }else{
            var msg = (data.result.length > 1) ? "Il suo indirizzo email è associato a più contatti, la preghiamo di contattare la segreteria per risolvereil problema!" : "Siamo spiacenti lei non risulta tra i nostri contatti"
            this.$alert(msg, "ATTENZIONE" ,{confirmButtonText: 'Chiudi' })
          }
        })

      }else{
        this.$notify.error({title: 'Errore',message: "La email è obbligatoria"})
      }
      
    },
    goLogin(event) {
      var errors = []

      if(this.form.email=='')
        errors.push('La email è obbligatoria')
      if(this.form.password=='')
        errors.push('La password è obbligatoria')

              
      if(errors.length>0){
        this.$alert(errors.join('<br />'),'LOGIN ERROR',{type: 'error',dangerouslyUseHTMLString: true})
      }else{
        this.axios.query('fetchRow','SELECT DISTINCT ana.id AS id, ana.cognome, ana.nome, ana.password, ana.email, codicefiscale FROM bm_bvent.contatto AS ana WHERE ana.email = →email AND ana.password = →password ORDER BY ana.cognome,ana.nome',this.form).then((data) => {
          console.log("LOGIN CHECK")
          console.log(this.$teras.utente)
          console.log(data)
          if(data.result.id > 0){
              this.$teras.utente = data.result
              this.$teras.event.emit('afterlogin')
              this.$teras.save("utente",this.$teras.utente)
              this.$teras.app.auth = true
              this.$router.push('/mylogin-home')
          }else{
            this.$alert('Email o password errate!','LOGIN ERROR',{type: 'error',dangerouslyUseHTMLString: true})
          }
        })

      }
    },
    goLogsssin() {
      console.log(this.$teras)
      this.axios.query('fetchRow','SELECT DISTINCT ana.id AS id, ana.cognome, ana.nome, ana.password, ana.email, codicefiscale FROM bm_bvent.contatto AS ana WHERE ana.email = →email AND ana.password = →password ORDER BY ana.cognome,ana.nome',this.form).then((data) => {
        console.log("LOGIN CHECK")
        console.log(this.$teras.utente)
        console.log(data)
        if(data.result.id > 0){
            this.$teras.utente = data.result
            this.$teras.step = -1
            this.$teras.event.emit('afterlogin')
            this.$teras.save("utente",this.$teras.utente)
            this.$teras.app.auth = true
            this.$router.push('/home')
        }else{
          this.$notify.error({title: 'Errore',message: "ERRORE DI AUTENTICAZIONE"});
        }
      })
    }
  }
}
</script>


<style>
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}
.catalogo-fad .header{
   background-image:url('../assets/catalogo-fad.png');
}
.fad-evidenza{
   padding-top:10px;
   height:170px;overflow:hidden;
}
.fad-evidenza:first-child{
   padding-top:20px;
   height:180px;overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Mylogin.vue